module.exports = __webpack_public_path__ + "88a7d230baf9712ad00f6aacd5413a72.woff2";